const config = {
  node: {
    env: process.env.NODE_ENV
  },
  build: {
    env: process.env.BUILD_ENV
  },
  api: {
    baseURL: process.env.API_BASE_PATH,
    timeout: 30000
  },
  auth: {
    baseURL: process.env.AUTH_BASE_PATH
  },
  sentry: {
    apiNoResponse: true,
    apiTimeout: true,
    apiRedirect: true,
    apiServerError: true,
    apiUnauthorized: true,
    apiForbidden: true,
    apiBadRequest: true
  }
}

export default config
